var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("耕地作业中")]),_c('div',[_vm._v("农机型号："+_vm._s(_vm.info.machineType))]),_c('div',[_vm._v("本次作业时长："+_vm._s(_vm.info.workTime))])])
}
var staticRenderFns = []

export { render, staticRenderFns }